// extracted by mini-css-extract-plugin
export default {"formPopup":"LeaveModal_formPopup--c15","generalBlock":"LeaveModal_generalBlock--vCi","overlay":"LeaveModal_overlay--yIs","closeBtn":"LeaveModal_closeBtn--GfY"};